module.exports = "/images/back-button.svg?4c4a35b4f023ae94f3bef72d5f6ca6ec";